var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStep8To9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 218,
    viewBox: "0 0 90 218",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7071 209.293C19.0976 209.683 19.0976 210.317 18.7071 210.707L12.3431 217.071C11.9526 217.462 11.3195 217.462 10.9289 217.071C10.5384 216.681 10.5384 216.047 10.9289 215.657L16.5858 210L10.9289 204.343C10.5384 203.953 10.5384 203.319 10.9289 202.929C11.3195 202.538 11.9526 202.538 12.3431 202.929L18.7071 209.293ZM11.0007 1.00001L11.0007 2.00001L11.0007 1.00001ZM90 2.00005L11.0007 2.00001L11.0007 1.43845e-05L90 5.32545e-05L90 2.00005ZM2.00072 11L2.00004 200L3.62586e-05 200L0.000721559 11L2.00072 11ZM11 209L18 209L18 211L11 211L11 209ZM2.00004 200C2.00002 204.971 6.02946 209 11 209L11 211C4.92489 211 1.42235e-05 206.075 3.62586e-05 200L2.00004 200ZM11.0007 2.00001C6.03017 2.00001 2.00074 6.02943 2.00072 11L0.000721559 11C0.000743594 4.92487 4.9256 1.49156e-05 11.0007 1.43845e-05L11.0007 2.00001Z",
    fill: "#134046"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep8To9);
export default __webpack_public_path__ + "static/media/step_8_to_9.955f5b11b1f0825aef53b6d2b53bcd51.svg";
export { ForwardRef as ReactComponent };